 <!-- 我的报名 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的证书</p>
      </div>
    </div>
    <div class="certificate">
      <span class="certificate-obtained">证书申请</span>
      <div style="display: flex;margin-top: 36px;">
        <ul class="certificate-ul" style="display: flex;flex-wrap: wrap; justify-content: space-between;">
          <li class="certificate-ul-item">
            <el-image
              style="width: 100%; height: 140px;"
              :src="item.certImg" 
              :preview-src-list="[item.certImg]">
            </el-image>
            <p class="certificate-ul-item-name">{{item.certName}}</p>
              <el-button v-if="item.applyStatus == 0" type="warning" size="small" style="width: 100%;background-color: #ff821c" :loading="loading"  @click="applyCert(item.id)" >立即申请</el-button>
              <el-button v-else-if="item.applyStatus == 1" type="warning" disabled size="small" style="width: 100%;">审核中</el-button>
              <el-button v-else-if="item.applyStatus == 3" type="warning" size="small" style="width: 100%;background-color: #ff821c" :loading="loading"  @click="applyCert(item.id)" >重新申请</el-button>
            
          </li>
        </ul>
        <div class="certificate-right">
          <div class="certificate-right-synopsis">
              <p class="certificate-right-synopsis-key">证书简介</p>
              <p class="certificate-right-synopsis-val" v-html="item.certificate.certDesc"></p>
          </div>
          <div class="certificate-right-synopsis">
              <p class="certificate-right-synopsis-key">申请条件</p>
              <p class="certificate-right-synopsis-val" v-html="item.certificate.applyCondition"></p>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import {certInfo,userCertInfo,applyCert} from '../../api/userMG'
export default {
  data() {
    return {
      id:'',
      item:{},
      type:1,
      loading:false
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.id = this.$route.query.id;
    let index = this.$route.query.index;
    this.type = index;
    // if(index==1){
      this.userCertInfo();
    // }else{
      // this.certInfo();
    // }
  },
  methods:{
    async certInfo(){
      await certInfo({certId:this.id}).then(res => {
        console.log('我的证书详情',res);
        this.item = res.data;
      })
      .catch(err => {
        
      })
    },
    async userCertInfo(){
      await userCertInfo({userCertId:this.id}).then(res => {
        console.log('我的证书详情',res);
        this.item = res.data;
      })
      .catch(err => {
        
      })
    },
    async applyCert(id){
      this.loading = true;
      await applyCert({id:id}).then(res => {
        console.log('证书申请',res);
        this.loading = false;
        if(res.code == 0){
          this.$message({
            message: '已提交申请',
            type: 'success',
            offset:100
          })
        }else{
          this.$message({
            message: res.smg,
            type: 'success',
            offset:100
          })
        }
      })
      .catch(err => {
        this.loading = false;
      })
    }
    
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }

  .certificate{
    padding: 26px 0 0;
  }
  .certificate-obtained{
    font-size: 14px;
    color: #f25902;
    padding: 10px 6px;
    border-bottom: 2px solid #f25902;
    margin: 0 4px;
  }
  .certificate-ul{
    margin-right: 36px;
  }
  
  .certificate-ul-item{
    width: 199px;
    height: 211px;
    padding: 12px;
    border: 1px solid #d6d6d6;
  }

  .certificate-ul-item-name{
    text-align: center;
    font-size: 13px;
    color: black;
    padding: 8px 0 10px;
  }

  .certificate-right-synopsis{
    margin-bottom: 24px;
  }
  .certificate-right-synopsis-key{
    font-size: 13px;
    color: black;
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 8px;
    margin-bottom: 16px;
  }
  .certificate-right-synopsis-val{
    font-size: 12px;
    color: #9a9a9a;
    line-height: 20px;
  }

</style>


// WEBPACK FOOTER //
// src/views/certificate/certificateDetails.vue